module.exports = __webpack_public_path__ + "static/media/0a.ad94fc52.png";